// Debug logging utility for role view filtering
// Set to false in production to disable verbose logging
export const DEBUG_ROLE_VIEW = false;

export const debugLog = (prefix: string, ...args: any[]) => {
  if (DEBUG_ROLE_VIEW) {
    console.log(prefix, ...args);
  }
};
